export default "__VITE_ASSET__DL2WTPKa__"